/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { useSelector } from 'react-redux';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getAsyncFocusedThreadDetails } from '../../thread-details/selectors/getAsyncFocusedThreadDetails';
import { getInboxId, getOriginalGenericChannelId } from 'conversations-thread-data/thread-details/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
export const withChannelsData = WrappedComponent => props => {
  const asyncThreadDetails = useSelector(getAsyncFocusedThreadDetails);
  const threadDetails = getData(asyncThreadDetails);

  // this breaks the getCurrentThreadInboxId selector's
  // abstractionn a bit, but because we can't call
  // useThreadDetails without a threadId, we have to rely on
  // some other context having fetched the thread before
  // we render--this safely ensures the inboxId is present
  if (isLoading(asyncThreadDetails) && !threadDetails) return /*#__PURE__*/_jsx(SkeletonText, {
    width: 200
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    inboxId: getInboxId(threadDetails),
    genericChannelId: getOriginalGenericChannelId(threadDetails)
  }));
};